import {Container, Text} from '@volkswagen-onehub/components-core'
import styled from 'styled-components'

export const TitleLayer = styled(Text)`
    margin: ${(props) => props.theme.size.static450} auto
        ${(props) => props.theme.size.static150};
`
export const ThanksTitle = styled(Text)`
    margin: 0 0 ${(props) => props.theme.size.static500};
`
export const CloseLayerContainer = styled(Container)`
    padding-right: 5px;
`
export const LayerForm = styled.form`
    label p {
        line-height: 14px;
    }
    &.no-logged {
        margin-top: ${(props) => props.theme.size.static500};
    }
`
export const FooterTextContainer = styled.div`
    border-top: 2px solid ${(props) => props.theme.colors.border.disabled};
    padding: ${(props) => props.theme.size.dynamic0250} 0 0;
    margin: ${(props) => props.theme.size.dynamic0250} 0 0;
`
export const ContainerFooterCTA = styled.div`
    margin: ${(props) => props.theme.size.static400} 0 0;
`
